import type { DeliverablePlatform, IDeliverable } from '../redux/buzzbridge/types';

export const DELIVERABLE_TYPE_LABELS: Record<string, string> = {
    instagram_post: 'Instagram Post',
    instagram_reel: 'Instagram Reel',
    instagram_story: 'Instagram Story',
    tiktok_video: 'TikTok Video',
    tiktok_short: 'TikTok Short',
    youtube_short: 'YouTube Short',
    youtube_video: 'YouTube Video',
    twitter_post: 'Twitter/X Post',
    facebook_post: 'Facebook Post',
    ugc_video: 'UGC Video',
    ugc_photo: 'UGC Photo',
    vertical: 'Vertical Video',
    horizontal: 'Horizontal Video',
};

/** Convert an IDeliverable to its human-readable display label. */
export function deliverableLabel(d: IDeliverable): string {
    const base = DELIVERABLE_TYPE_LABELS[d.type] ?? d.type;
    return d.count > 1 ? `${d.count}× ${base}` : base;
}

/** Convert an IDeliverable[] to a string[] of display labels. */
export function deliverableLabels(deliverables: IDeliverable[]): string[] {
    return deliverables.map(deliverableLabel);
}

/** Resolve platform for icon display — prefer explicit field, else infer from type. */
export function resolveDeliverablePlatform(
    d: IDeliverable,
): Extract<DeliverablePlatform, 'instagram' | 'tiktok' | 'youtube' | 'twitter' | 'facebook'> | 'other' {
    const p = d.platform === 'x' ? 'twitter' : d.platform;
    if (p === 'instagram' || p === 'tiktok' || p === 'youtube' || p === 'twitter' || p === 'facebook') {
        return p;
    }
    const type = d.type ?? '';
    if (type.startsWith('instagram')) return 'instagram';
    if (type.startsWith('tiktok')) return 'tiktok';
    if (type.startsWith('youtube')) return 'youtube';
    if (type.startsWith('twitter')) return 'twitter';
    if (type.startsWith('facebook')) return 'facebook';
    return 'other';
}
